import React from 'react'
import { useTranslation } from 'react-i18next'
import TextInputControlled from '../../inputs/TextInput/controlled'
import { WaiterDiscountInputWrapper, WaiterTimeError, WaiterTimeSelectWrapper } from './index.styled'
import SelectInputControlled from '../../inputs/SelectInput/controlled'
import { CartSettingItemContent, CartSettingItemTitle, CartSettingItemWrap } from '../../../RestaurantCartSettings/index.styled'

const WaiterCartSettings = React.memo(({ waiterLogoutHours, waiterLogoutMinutes, onChangeWaiterLogoutTime, minWaiterLogoutTime, timeError, waiterDiscount, onChangeWaiterDiscount, onBlurWaiterDiscount, showWaiterDiscountCheck, discountError, className }) => {
	const { t } = useTranslation()
	const hours = Array.from({ length: 24 }, (_, i) => i < 10 ? `0${i}` : `${i}`)
	const minutes = Array.from({ length: 60 }, (_, i) => i < 10 ? `0${i}` : `${i}`)
	const timeInputLayout = (timeError ? 'error ' : '')
	const layout =  'lf-col-2' + (className ? ` ${className}` : '')

	return (
		<>
			<CartSettingItemWrap className={layout}>
				<CartSettingItemContent>
					<CartSettingItemTitle>{t('Settings.WaiterCartSettings.waiterTimeSetting')}</CartSettingItemTitle>
					<WaiterTimeError className={timeInputLayout}>{t('Settings.WaiterCartSettings.error.time_error', { minutes: minWaiterLogoutTime })}</WaiterTimeError>
					<WaiterTimeSelectWrapper className="full-width">
						<SelectInputControlled name="hours"
																	 value={waiterLogoutHours}
																	 color={timeInputLayout}
																	 onChange={(e) => onChangeWaiterLogoutTime(e, 'hours')}>
							{hours.map(hour => (
								<option key={hour} value={hour}>
									{hour}
								</option>
							))}
						</SelectInputControlled>
						<span>:</span>
						<SelectInputControlled name="minutes"
																	 value={waiterLogoutMinutes}
																	 color={timeInputLayout}
																	 onChange={(e) => onChangeWaiterLogoutTime(e, 'minutes')}>
							{minutes.map(minute => (
								<option key={minute} value={minute}>
									{minute}
								</option>
							))}
						</SelectInputControlled>
					</WaiterTimeSelectWrapper>
				</CartSettingItemContent>
				<CartSettingItemContent>
					<CartSettingItemTitle>{t('Settings.WaiterCartSettings.waiterMaxDiscount')}</CartSettingItemTitle>
					<WaiterDiscountInputWrapper>
						<TextInputControlled name="waiter-discount"
																 testId="waiter-discount"
																 label={t('Settings.WaiterCartSettings.discount')}
																 value={waiterDiscount}
																 onChange={onChangeWaiterDiscount}
																 onBlur={onBlurWaiterDiscount}
																 showCheck={showWaiterDiscountCheck}
																 errorMessage={discountError}
																 color="gray" />
					</WaiterDiscountInputWrapper>
				</CartSettingItemContent>
			</CartSettingItemWrap>
		</>
	)
})

WaiterCartSettings.displayName = 'WaiterCartSettings'
export default WaiterCartSettings
